
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/valbara-kurser",
      function () {
        return require("private-next-pages/valbara-kurser.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/valbara-kurser"])
      });
    }
  